const getLabels = (value: string, options: { label: string, value: string }[]) => {
  const label = options.find((option) => option.value === value);
  return label?.label;
};

export default getLabels;
